import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private jwtHelper = new JwtHelperService();

  constructor() {}

  get contactId() {
    if (!this.authorizationToken) {
      return null;
    }

    const decodedToken = this.jwtHelper.decodeToken(this.authorizationToken);
    return decodedToken.CONTACT_ID;
  }

  get authorizationToken() {
    const re = /OESSOTOK=(.*?)(;|$)/;
    if (!re.test(document.cookie)) {
      return null;
    }

    return re.exec(document.cookie)[1];
  }
}
